<!----
    Author: hjlee
    Description:
        입력 컨트롤
---->
<template>
  <div
    v-if="isMounted && isVisibleControl()"
    class="input-control"
    :data-vv-scope="scope"
    :input-control-name="uniqueName"
    :readonly="readonly"
    :disabled="disabled"
    :type="type"
  >
    <label v-if="!noTitle && (type !== 'checkbox' || checkboxLabel)" class="item-label" :for="modalName + '-' + name">{{ title ? title : $t(modalName + '.label.' + name) }}<span v-if="required" class="required">*</span></label>
    <multifile-uploader
      v-if="type === 'multifile' || type === 'singlefile'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      :ref="'file-upload-' + idPrefix + modalName + '-' + name + idPostfix + 'Ref'"
      v-model="inputVal"
      :show-circle="showCircle"
      :no-delete-button="noDeleteButton"
      :no-control-area="noControlArea"
      v-validate="computedRules"
      :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && (inputVal && inputVal.length > 0)}"
      :autofocus="autofocus"
      :name="uniqueName"
      :is-image="isImagePurpose(fileInfo.purpose)"
      :accept="fileInfo.accept"
      :max-file-size="fileInfo.maxFileSize"
      :custom-click-event="customClickEvent"
      :use-primary="fileInfo.usePrimary"
      :purpose="fileInfo.purpose"
      :table-name="tableName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :multiple="type === 'multifile'"
      :max-files="fileInfo.maxFiles"
      :default-image="fileInfo.defaultImage"
      :camera-button-image="cameraButtonImage"
      :preview="showImageViewer"
      :cover="coverImage"
      @change="onChangedWithVal(inputVal, $event)"
      @changed="onChangedFile($event)"
      @custom-click-event="onCustomClickEvent"
    />
    <b-form-checkbox
      v-else-if="type === 'checkbox'"
      :id="idPrefix + modalName + '-' + name + (index ? index : '') + idPostfix"
      :key="idPrefix + modalName + '-' + name + (index ? index : '') + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal, 'has-checkbox-label': checkboxLabel}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :required="required"
      :disabled="readonly || disabled"
      :placeholder="placeholderText()"
      :value="name.endsWith('_flag')?'Y':true"
      :unchecked-value="name.endsWith('_flag')?'N':false"
      :switch="isSwitch"
      @change="onChangedCheckbox"
    >
      {{ checkboxLabel ? $t(checkboxLabel) : (title ? title : $t(modalName + '.label.' + name)) }}<span v-if="required" class="required">*</span>
    </b-form-checkbox>
    <b-form-select
      v-else-if="type === 'select'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :options="options"
      :tabindex="tabindex"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :required="required"
      :disabled="readonly || disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <multiple-select
      v-else-if="type === 'multiselect'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :options="options"
      :multiple="multiple"
      :orderable="orderable"
      :async-search-url="asyncSearchUrl"
      :async-search-method="asyncSearchMethod"
      label="text"
      :select-label="$t('common.label.press_enter_to_select')"
      :select-group-label="$t('common.label.press_enter_to_select_group')"
      :deselect-label="$t('common.label.press_enter_to_remove')"
      :deselect-group-label="$t('common.label.press_enter_to_deselect_group')"
      :tag-placeholder="$t('common.label.press_enter_to_create_a_tag')"
      :selected-label="$t('common.label.selected')"
      track-by="value"
      :disabled="readonly || disabled"
      :required="required"
      :placeholder="placeholderText()"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && (inputVal && inputVal.length > 0)}"
      :autofocus="autofocus"
      :name="uniqueName"
      :visible-data="visibleData"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <b-form-select
      v-else-if="type === 'multiselect_list'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :options="options"
      :multiple="true"
      :required="required"
      :disabled="readonly || disabled"
      :placeholder="placeholderText()"
      :class="{'is-invalid': hasValidationRules(computedRules) && (hasError || !inputVal || inputVal.length === 0), 'is-valid': hasValidationRules(computedRules) && !hasError && (inputVal && inputVal.length > 0)}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <hierarchy-selector
      v-else-if="type === 'hierarchy_select'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :fetching-children-url="fetchingChildrenUrl"
      :get-initial-value-url="getInitialValueUrl"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :required="required"
      :disabled="readonly || disabled"
      :placeholder="placeholderText()"
    />
    <textarea
      v-else-if="type === 'textarea'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedTextarea($event)"
      @keyup="onKeyUpTextarea($event)"
    />
    <datetime-picker
      v-else-if="type === 'date'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :config="dateConfig"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @dp-change="onChangedWithVal(inputVal, $event)"
    />
    <datetime-picker
      v-else-if="type === 'datetime'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :config="datetimeConfig"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @dp-change="onChangedWithVal(inputVal, $event)"
    />
    <datetime-picker
      v-else-if="type === 'time'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :config="timeConfig"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @dp-change="onChangedWithVal(inputVal, $event)"
    />
    <simple-date-picker
      v-else-if="type === 'date_simple_string'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :config="datetimeConfig"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <i18n
      v-else-if="type === 'i18n'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <global-map
      v-else-if="type === 'map'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :auto-search-location="autoSearchLocation"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <page-selector
      v-else-if="type === 'page_selector'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :rules="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :visible-data="visibleData"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <bbs-selector
      v-else-if="type === 'bbs_selector'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :rules="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :visible-data="visibleData"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <service-selector
      v-else-if="type === 'service_selector'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :rules="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :visible-data="visibleData"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <category-selector
      v-else-if="type === 'category_selector'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :rules="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :visible-data="visibleData"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <user-selector
      v-else-if="type === 'user_selector'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :rules="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :visible-data="visibleData"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <icon-selector
      v-else-if="type === 'icon'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :rules="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :type="type"
      :name="uniqueName"
      :title="title"
      :modal-name="modalName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      data-vv-validate-on="change"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <html-editor
      v-else-if="type === 'html_editor'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'html-editor-area': true, 'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :editor-options="editorOptions"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <earn-point
      v-else-if="type === 'earn_point'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'point-area': true, 'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <point
      v-else-if="type === 'point'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'point-area': true, 'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <color-picker
      v-else-if="type === 'color'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'color-picker-area': true, 'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <credit-card
      v-else-if="type === 'creditcard'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'creditcard-area': true, 'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <name-input
      v-else-if="type === 'name'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :use-middle-name="useMiddleName"
      :class="{'name-area': true, 'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <vue-tel-input
      v-else-if="!staticLocale && type === 'tel' && configs.only_for_korea_republic_of !== 'true'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :input-id="idPrefix + modalName + '-' + name + idPostfix"
      :class="{'vue-tel-input-area': true, 'form-control': true, 'is-invalid': hasInvalidTel || hasError, 'is-valid': !hasInvalidTel && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :required="required"
      :data-vv-as="title?title:(name?$t(modalName + '.label.' + name):undefined)"
      :disabled="disabled || readonly"
      :placeholder="placeholderText()"
      @input="onVueTelInput"
    />
    <currency-selector
      v-else-if="type === 'currency'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :class="{'is-invalid': hasValidationRules(computedRules) && (hasError || !inputVal || inputVal.length === 0), 'is-valid': hasValidationRules(computedRules) && !hasError && (inputVal && inputVal.length > 0)}"
      :autofocus="autofocus"
      :name="uniqueName"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <currency-input
      v-else-if="type === 'price'"
      :id="idPrefix + modalName + '-' + name + idPostfix"
      :key="idPrefix + modalName + '-' + name + idPostfix"
      v-model="inputVal"
      v-validate="computedRules"
      :currency="staticCurrency ? staticCurrency : ((visibleData && visibleData.currency)?visibleData.currency:defaultCurrency)"
      :currency-symbol="currencySymbol"
      :decimal-length="2"
      :minimum-fraction-digits="0"
      :position="currencyPosition"
      :class="{'form-control': true, 'is-invalid': hasInvalidTel || hasError, 'is-valid': !hasInvalidTel && !hasError && inputVal}"
      :autofocus="autofocus"
      :name="uniqueName"
      :locale="getCurrencyLocale()"
      :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChangedWithVal(inputVal, $event)"
    />
    <div v-else-if="type === 'tel_or_email'" class="input-group">
      <div v-if="!disabled && !readonly && configs.only_for_korea_republic_of !== 'true' && configs.account_system === 'tel_or_email'" class="user-id-type-area">
        <input
          id="user-type-email-for-registration"
          v-model="inputValType"
          type="radio"
          name="userIdTypeForRegistration"
          value="email"
          :disabled="disabled || readonly"
          @click="onClickedInputValType"
          :tabindex="tabindex"
          @keypress="onKeypress($event)"
        >&nbsp;
        <label for="user-type-email-for-registration">{{ $t('code.nm.value_type.email') }}</label> &nbsp; &nbsp; &nbsp; &nbsp;
        <input
          id="user-type-tel-for-registration"
          v-model="inputValType"
          type="radio"
          name="userIdTypeForRegistration"
          value="tel"
          :disabled="disabled || readonly"
          :tabindex="tabindex"
          @keypress="onKeypress($event)"
          @click="onClickedInputValType"
        >&nbsp;
        <label for="user-type-tel-for-registration">{{ $t('code.nm.value_type.tel') }}</label>
        <div class="clear" />
      </div>
      <div v-if="!staticLocale && configs.only_for_korea_republic_of !== 'true' && (configs.account_system === 'tel' || (configs.account_system === 'tel_or_email' && inputValType === 'tel'))" class="user-id-area">
        <div class="clear" />
        <vue-tel-input
          :id="idPrefix + modalName + '-' + name + idPostfix"
          :key="'user-id-tel-' + idPrefix + modalName + '-' + name + idPostfix"
          v-model="inputVal"
          :placeholder="$t('login_modal.placeholder.username') + (configs?'(' + $t('code.nm.value_type.' + (configs.account_system?configs.account_system:'tel_or_email')) + ')':'')"
          :class="{'vue-tel-input-area': true, 'form-control': true, 'is-invalid': hasInvalidTel || hasError, 'is-valid': !hasInvalidTel && !hasError && inputVal}"
          :autofocus="autofocus"
          :name="uniqueName"
          :data-vv-as="title?title:(name?$t(modalName + '.label.' + name):undefined)"
          :disabled="disabled || readonly"
          :required="required"
          @input="onVueTelInput"
        />
        <input id="login-username" key="user-id-tel-hidden" type="hidden" :value="inputVal">
      </div>
      <div v-else class="user-id-area">
        <div class="clear" />
        <input
          :id="idPrefix + modalName + '-' + name + idPostfix"
          :key="'user-id-mail-' + idPrefix + modalName + '-' + name + idPostfix"
          v-model="inputVal"
          v-validate="computedRules"
          :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
          :autofocus="autofocus"
          :type="type"
          :name="uniqueName"
          :data-vv-as="title?title:(name?$t(modalName + '.label.' + name):undefined)"
          :readonly="readonly"
          :required="required"
          :disabled="disabled"
          :placeholder="placeholderText()"
          @change="onTelOrEmailChanged($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
          :tabindex="tabindex"
          @keypress="onKeypress($event)"
        >
      </div>
    </div>
    <div v-else-if="mask" class="input-group">
      <div v-if="prefix" class="input-group-prepend">
        <span class="input-group-text">
          {{ prefix }}
        </span>
      </div>
      <input
        :id="idPrefix + modalName + '-' + name + idPostfix"
        :key="idPrefix + modalName + '-' + name + idPostfix"
        v-model="inputVal"
        v-validate="computedRules"
        v-mask="mask"
        :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
        :autofocus="autofocus"
        :type="type"
        :name="uniqueName"
        :min="min"
        :max="max"
        :data-vv-as="title ? title : (name?$t(modalName + '.label.' + name):undefined)"
        :readonly="readonly"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholderText()"
        @change="onChangedText($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        :tabindex="tabindex"
        @keypress="onKeypress($event)"
      >
      <div v-if="postfix" class="input-group-append">
        <span class="input-group-text">
          {{ postfix }}
        </span>
      </div>
    </div>
    <div v-else-if="type === 'video'">
      <div class="input-group video-area">
        <div v-if="prefix" class="input-group-prepend">
          <span class="input-group-text">
            {{ prefix }}
          </span>
        </div>
        <input
          :id="idPrefix + modalName + '-' + name + idPostfix"
          :key="idPrefix + modalName + '-' + name + idPostfix"
          v-model="inputVal"
          v-validate="computedRules"
          :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal}"
          :autofocus="autofocus"
          :type="type"
          :name="uniqueName"
          :data-vv-as="title?title:(name?$t(modalName + '.label.' + name):undefined)"
          :readonly="readonly || isPreview"
          :required="required"
          :disabled="disabled"
          :placeholder="placeholderText()"
          @change="onChangedText($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
          :tabindex="tabindex"
          @keypress="onKeypress($event)"
        >
        <div v-if="postfix" class="input-group-prepend">
          <span class="input-group-text">
            {{ postfix }}
          </span>
        </div>
        <div class="input-group-prepend">
          <button v-if="!isPreview" class="btn btn-primary" @click="preview()">
            {{ $t('common.button.start_preview') }}
          </button>
          <button v-else class="btn btn-primary" @click="isPreview = !isPreview">
            {{ $t('common.button.stop_preview') }}
          </button>
        </div>
      </div>
      <div v-if="typeCodeFieldName && (visibleData[typeCodeFieldName] === 'video_type.vimeo') && isPreview">
        <my-vimeo-player :video-id="inputVal" :player-width="playerWidth" @error="onVimeoError" />
        <b-alert
          :show="!!vimeoError"
          variant="warning"
        >
          {{ vimeoError }}
        </b-alert>
      </div>
      <div v-if="typeCodeFieldName && (visibleData[typeCodeFieldName] === 'video_type.youtube') && isPreview">
        <my-youtube-player :video-id="inputVal" :player-width="playerWidth" @error="onYoutubeError" />
        <b-alert
          :show="!!youtubeError"
          variant="warning"
        >
          {{ youtubeError }}
        </b-alert>
      </div>
    </div>
    <div v-else :class="{'input-group': true, 'force-flex': prefix || postfix}">
      <div v-if="prefix" class="input-group-prepend">
        <span class="input-group-text">
          {{ prefix }}
        </span>
      </div>
      <input
        :id="idPrefix + modalName + '-' + name + idPostfix"
        :key="idPrefix + modalName + '-' + name + idPostfix"
        v-model="inputVal"
        v-validate="computedRules"
        :class="{'form-control': true, 'is-invalid': hasValidationRules(computedRules) && hasError, 'is-valid': hasValidationRules(computedRules) && !hasError && inputVal, 'width-auto': type === 'zip'}"
        :autofocus="autofocus"
        :type="type"
        :name="uniqueName"
        :min="min"
        :max="max"
        :data-vv-as="title?title:(name?$t(modalName + '.label.' + name):undefined)"
        :readonly="readonly"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholderText()"
        @change="onChangedText($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        :tabindex="tabindex"
        @keypress="onKeypress($event)"
      >
      <div v-if="type === 'zip'" class="input-group-append">
        <button class="btn btn-secondary width-full" @click="findZip">
          {{ $t('common.button.zip') }}
        </button>
      </div>
      <div v-if="postfix" class="input-group-append">
        <span class="input-group-text">
          {{ postfix }}
        </span>
      </div>
    </div>
    <div class="clear" />
    <div v-if="notifications && notifications.length > 0">
      <pig-tail-label v-for="(notification, notificationIndex) in notifications" :key="notificationIndex" :message="$t(getCharstCode(notification))" />
    </div>
    <div v-show="!hasError && inputVal && validMessage" :class="{'valid-feedback': true, 'show-valid': !hasInvalidTel && !hasError && inputVal && validMessage}" v-html="validMessage" />
    <div v-show="hasError" :class="{'invalid-feedback': true, 'show-invalid': hasError || hasInvalidTel}" v-html="getFirstError()" />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    modalName: {
      type: String,
      default: 'common'
    },
    cameraButtonImage: {
      type: String,
      default: undefined
    },
    showImageViewer: {
      type: Boolean,
      default: true
    },
    coverImage: {
      type: Boolean,
      default: true
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    validMessage: {
      type: String,
      default: ''
    },
    customClickEvent: {
      type: String,
      default: ''
    },
    nodeDepth: {
      type: Number,
      default: 0
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: undefined
    },
    name: {
      type: String,
      default: ''
    },
    useMiddleName: {
      type: Boolean,
      default: true
    },
    defaultCurrency: {
      type: [String, Object],
      default: 'KRW'
    },
    currencySymbol: {
      type: String,
      default: undefined
    },
    currencyPosition: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    tabindex: {
      type: Number,
      default: 0
    },
    idPrefix: {
      type: String,
      default: ''
    },
    idPostfix: {
      type: String,
      default: ''
    },
    checkboxLabel: {
      /* 체크박스 라벨. 라벨이 있는 경우 타이틀을 따로 표시한다. */
      type: String,
      default: ''
    },
    fetchingChildrenUrl: {
      type: String,
      default: ''
    },
    getInitialValueUrl: {
      type: String,
      default: ''
    },
    notifications: {
      type: Array,
      default: undefined
    },
    mask: {
      type: String,
      default: undefined
    },
    rules: {
      type: [String, Object],
      default: ''
    },
    showCircle: {
      type: Boolean,
      default: false
    },
    min: {
      type: [String, Number],
      required: false,
      default: undefined
    },
    max: {
      type: [String, Number],
      required: false,
      default: undefined
    },
    prefix: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    purpose: {
      type: String,
      default: 'general'
    },
    type: {
      type: String,
      default: 'text'
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    editorOptions: {
      type: Object,
      default: undefined
    },
    fileInfo: {
      type: Object,
      default: undefined
    },
    tableName: {
      type: String,
      default: ''
    },
    visibleData: {
      type: Object,
      default: undefined
    },
    staticLocale: {
      type: String,
      default: ''
    },
    staticCurrency: {
      type: String,
      default: ''
    },
    visibleBy: {
      type: Array,
      default: undefined
    },
    visibleType: {
      type: String,
      default: ''
    },
    masterSelectedRow: {
      type: Object,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true
    },
    autoSearchLocation: {
      type: Boolean,
      default: false
    },
    autoResize: {
      type: Boolean,
      default: false
    },
    typeCodeFieldName: {
      type: String,
      default: ''
    },
    withFields: {
      type: Array,
      default: undefined
    },
    asyncSearchUrl: {
      type: String,
      default: undefined,
      required: false
    },
    asyncSearchMethod: {
      type: String,
      default: 'GET',
      required: false
    },
    orderable: {
      type: Boolean,
      default: false
    },
    noDeleteButton: {
      type: Boolean,
      default: false
    },
    noControlArea: {
      type: Boolean,
      default: false
    },
    isSwitch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isMounted: false,
      inputVal: '',
      inputValType: '',
      vimeoError: undefined,
      youtubeError: undefined,
      isPreview: false,
      dateConfig: {
        format: this.$t('common.format.date'),
        locale: this.$store.state.locale
      },
      scope: undefined,
      datetimeConfig: {
        format: this.$t('common.format.datetime'),
        locale: this.$store.state.locale
      },
      timeConfig: {
        format: this.$t('common.format.time'),
        locale: this.$store.state.locale
      },
      index: undefined,
      hasInvalidTel: false,
      playerWidth: 300
    }
  },
  computed: {
    uniqueName() {
      return this.name + '-' + this._uid
    },
    hasError() {
      const result = this.errors.has(this.uniqueName)
      if (!result) {
        if (this.$children && this.$children.length > 0) {
          if (this.type === 'creditcard') {
            for (let i = 0; i < this.$children.length; i++) {
              if (
                this.$children[i].errors &&
                this.$children[i].errors.items &&
                this.$children[i].errors.items.length > 0
              ) {
                return true
              }
            }
          }
        }
      }
      return result
    },
    computedRules: function() {
      const rules = this.parseValidationRules(this.rules)
      if (this.required) {
        if (this.type === 'creditcard') {
          rules.creditcard_required = true
        }
        rules.required = true
      }
      if (this.min !== undefined) {
        rules.min = this.min
      }
      if (this.max !== undefined) {
        rules.max = this.max
      }
      if (this.type === 'juridical_registration_number') {
        rules.juridical_registration_number = true
      }
      if (this.type === 'business_registration_number') {
        rules.business_registration_number = true
      }
      if (this.type === 'inhabitants_identification_number') {
        rules.inhabitants_identification_number = true
      }
      if (this.readonly) {
        delete rules.unique
      }
      return rules
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.inputVal = this.getDisplayText(newVal)
      },
      immediate: true,
      deep: true
    },
    hasError: function(newVal) {
      this.$forceUpdate()
    },
    inputValType: function(newVal) {
      this.inputVal = ''
    },
    inputVal: {
      handler: function(newVal) {
        if (!this.changedCount) {
          this.changedCount = 1
          if (this.type === 'hierarchy_select') {
            this.onInputPostprocess(newVal)
          }
        } else {
          this.changedCount++
          this.onInputPostprocess(newVal)
        }
        if (this.type === 'textarea' && this.autoResize) {
          this.resizeTextarea()
        }
      },
      deep: true
    }
  },
  created() {
    if (!window._inputControlIndex) {
      window._inputControlIndex = 0
    }
    this.index = window._inputControlIndex++
    this.scope = 'input-control-scope-' + this.index
    if (!window._inputControls) {
      window._inputControls = []
    }
  },
  mounted() {
    if (
      this.type === 'tel_or_email' &&
      !this.inputValType &&
      !this.disabled &&
      !this.readonly
    ) {
      this.inputValType = 'email'
    }
    this.inputVal = this.getDisplayText(this.value)
    if (this.type === 'select' && !this.inputVal) {
      this.inputVal = ''
    }
    if (this.type === 'textarea' && this.autoResize) {
      this.resizeTextarea()
    }
    this.isMounted = true
    this.$eventHub.$on('validate-input-control', this.validateInputControl)
  },
  beforeDestroy() {
    this.$eventHub.$off('validate-input-control', this.validateInputControl)
    if (this.inputTimer) {
      clearTimeout(this.inputTimer)
      this.inputTimer = undefined
    }
  },
  methods: {
    onChangedFile(e) {
      this.$emit('changed', e)
    },
    onKeypress(e) {
      this.$emit('keypress', e)
    },
    findZip() {
      console.log('find zip')
      this.$emit('find-zip')
    },
    getDisplayText(newVal) {
      let val
      if (this.type === 'inhabitants_identification_number') {
        val = this.$options.filters.formatInhabitantsIdentificationNumber(
          newVal
        )
      } else if (this.type === 'juridical_registration_number') {
        val = this.$options.filters.formatJuridicalRegistrationNumber(newVal)
      } else if (this.type === 'business_registration_number') {
        val = this.$options.filters.formatBusinessRegistrationNumber(newVal)
      } else if (
        this.type === 'tel' &&
        (this.configs.only_for_korea_republic_of === 'true' ||
          this.staticLocale === 'ko_kr')
      ) {
        val = this.$options.filters.formatKoreanTel(newVal)
      } else if (this.type === 'date' || this.type === 'datetime') {
        if (!isNaN(newVal)) {
          val = parseInt(newVal)
          val = moment(val).format(
            this.type === 'date'
              ? this.$t('common.format.date')
              : this.$t('common.format.datetime')
          )
        }
      } else {
        val = newVal
      }
      return val
    },
    getCurrencyLocale() {
      if (this.$i18n && this.$i18n.locale) {
        let locale = this.$i18n.locale.substring(0, 2).toLowerCase()
        locale += '-'
        locale += this.$i18n.locale.substring(3, 5).toLowerCase()
        return locale
      }
      return 'ko-KR'
    },
    preview() {
      this.playerWidth = $(this.$el).width()
      this.isPreview = true
      this.vimeoError = ''
      this.youtubeError = ''
    },
    onVimeoError(vimeoError) {
      this.vimeoError = vimeoError
    },
    onYoutubeError(youtubeError) {
      this.youtubeError = youtubeError
    },
    getFirstError() {
      if (this.type === 'credit_card') {
        if (this.$children && this.$children.length > 0) {
          for (let i = 0; i < this.$children.length; i++) {
            if (
              this.$children[i].errors &&
              this.$children[i].errors.items &&
              this.$children[i].errors.items.length > 0
            ) {
              return this.$children[i].errors.items[0].msg
            }
          }
        }
      }

      if (this.errors && this.errors.length > 0) {
        return this.errors.first(this.uniqueName)
      }
      if (this.errors && this.errors.items && this.errors.items.length > 0) {
        return this.errors.first(this.uniqueName)
      }
    },
    validateInputControl(name) {
      if (!name) {
        this.$validator.validate().then(result => {
          this.$eventHub.$emit('input-control-validated', {
            name: this.uniqueName,
            result
          })
        })
      } else if (this.uniqueName === name) {
        this.$validator.validate(name).then(result => {
          this.$eventHub.$emit('input-control-validated', {
            name: this.uniqueName,
            result
          })
        })
      }
    },
    isUploading() {
      if (this.type === 'multifile' || this.type === 'singlefile') {
        const refKey =
          'file-upload-' +
          this.idPrefix +
          this.modalName +
          '-' +
          this.uniqueName +
          this.idPostfix +
          'Ref'
        if (this.$refs[refKey]) {
          return this.$refs[refKey].isUploading()
        }
      }
      return false
    },
    placeholderText() {
      if (
        this.name === 'hmpg_url' &&
        this.visibleData &&
        this.visibleData.userId
      ) {
        return this.visibleData.userId
      }
      if (this.placeholder) {
        return this.placeholder
      } else if (this.title) {
        return this.title
      } else if (
        !this.hasNoText(
          this.modalName + '.placeholder.' + this.name.toSnakeCase()
        )
      ) {
        return this.$t(this.modalName + '.label.' + this.name.toSnakeCase())
      }
      return this.$t(this.modalName + '.placeholder.' + this.name.toSnakeCase())
    },
    onClickedInputValType() {
      this.$validator.reset()
    },
    onChangedText(e) {
      this.onChangedPostprocess(e, e.target.value)
    },
    resizeTextarea() {
      if (this.autoResize && this.type === 'textarea') {
        this.$nextTick(() => {
          const obj = $(this.$el)
            .find('textarea')
            .get(0)
          if (obj) {
            obj.style.height = '1px'
            obj.style.height = 'calc(1px + ' + obj.scrollHeight + 'px)'
          }
        })
      }
    },
    onKeyUpTextarea(e) {
      this.resizeTextarea()
    },
    onChangedTextarea(e) {
      this.resizeTextarea()
      this.onChangedDefault(e)
    },
    onChangedDefault(e) {
      this.onChangedPostprocess(e, e.target.value)
    },
    onTelOrEmailChanged(e) {
      if (this.type === 'tel_or_email' && e.target.value) {
        const value = e.target.value
        const val = value
          .replace(new RegExp('-', 'g'), '')
          .replace(new RegExp(' ', 'g'), '')
        if (!isNaN(val)) {
          e.target.value = this.$options.filters.formatKoreanTel(val)
        }
        this.setCaretPosition(e.target, e.target.value.length)
      }
      this.onChangedPostprocess(e, e.target.value)
    },
    onVueTelInput(text, obj) {
      this.hasInvalidTel = !obj.isValid
      if (obj && obj.number && obj.number.international) {
        this.inputVal = obj.number.international
      }
    },
    onChangedCheckbox(val) {
      this.onChangedPostprocess(undefined, val)
    },
    onChangedWithVal(val, e) {
      this.onChangedPostprocess(e, val)
    },
    /**
     * 변경된 경우 공통 이벤트로 처리
     */
    onChangedPostprocess(e, val) {
      if (e && e.preventDefault) {
        e.preventDefault()
        e.stopPropagation()
      }
      let emitVal = val
      if (this.type === 'inhabitants_identification_number') {
        e.target.value = this.$options.filters.formatInhabitantsIdentificationNumber(
          val
        )
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (this.type === 'juridical_registration_number') {
        e.target.value = this.$options.filters.formatJuridicalRegistrationNumber(
          val
        )
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (this.type === 'business_registration_number') {
        e.target.value = this.$options.filters.formatBusinessRegistrationNumber(
          val
        )
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (
        this.type === 'tel' &&
        (this.configs.only_for_korea_republic_of === 'true' ||
          this.staticLocale === 'ko_kr')
      ) {
        e.target.value = this.$options.filters.formatKoreanTel(val)
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (this.type === 'date' || this.type === 'datetime') {
        emitVal = moment(
          val,
          this.type === 'date'
            ? this.$t('common.format.date')
            : this.$t('common.format.datetime')
        ).valueOf()
      }

      this.$emit('input', emitVal)
      this.$emit('change', emitVal)
      this.$nextTick(() => {
        this.$forceUpdate()
        this.asyncValidate()
      })
    },
    onInputPostprocess(val) {
      if (this.inputTimer) {
        clearTimeout(this.inputTimer)
        this.inputTimer = undefined
      }
      let emitVal = val
      if (this.type === 'inhabitants_identification_number') {
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (this.type === 'juridical_registration_number') {
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (this.type === 'business_registration_number') {
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (
        this.type === 'tel' &&
        (this.configs.only_for_korea_republic_of === 'true' ||
          this.staticLocale === 'ko_kr')
      ) {
        if (val) {
          emitVal = val
            .replace(new RegExp('-', 'g'), '')
            .replace(new RegExp(' ', 'g'), '')
        }
      } else if (this.type === 'date' || this.type === 'datetime') {
        emitVal = moment(
          val,
          this.type === 'date'
            ? this.$t('common.format.date')
            : this.$t('common.format.datetime')
        ).valueOf()
      }
      this.inputTimer = setTimeout(() => {
        this.$emit('input', emitVal)
        this.asyncValidateProcess()
        this.inputTimer = undefined
      }, 300)
    },
    asyncValidate() {
      if (this.inputTimer) {
        clearTimeout(this.inputTimer)
        this.inputTimer = undefined
      }
      this.inputTimer = setTimeout(() => {
        this.asyncValidateProcess()
        this.inputTimer = undefined
      }, 300)
    },
    asyncValidateProcess() {
      let name = this.uniqueName
      if (this.type === 'i18n') {
        name = this.scope + '.*'
      }
      this.$validator.validate(name).then(() => {
        if (this.withFields && this.withFields.length > 0) {
          for (let i = 0; i < this.withFields.length; i++) {
            this.$eventHub.$emit('validate-input-control', this.withFields[i])
          }
        }
        this.emitForceUpdate()
      })
    },
    setCaretPosition: function(ctrl, pos) {
      // Modern browsers
      if (ctrl.setSelectionRange) {
        ctrl.focus()
        ctrl.setSelectionRange(pos, pos)
        // IE8 and below
      } else if (ctrl.createTextRange) {
        const range = ctrl.createTextRange()
        range.collapse(true)
        range.moveEnd('character', pos)
        range.moveStart('character', pos)
        range.select()
      }
    },
    initiateValue() {
      this.$emit('input', '')
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.errors.clear()
        })
      })
    },
    onFocus(e) {
      this.$emit('focus', e)
    },
    onBlur(e) {
      this.$emit('blur', e)
    },
    onCustomClickEvent(e) {
      this.$emit('custom-click-event', e)
    }
  }
}
</script>

<style scoped>
.required {
  padding-left: 10px;
  color: red;
  font-weight: bold;
}
.input-control {
  margin-bottom: 20px;
}
.upload-progress-area {
  width: 190px;
}
.show-valid,
.show-invalid {
  display: block !important;
}
.html-editor-area {
  height: auto;
  padding: 0;
}
.global-map.is-invalid {
  border: 1px solid #ff9999;
}
.html-editor-area.form-control.is-invalid,
.was-validated .html-editor-area.form-control:invalid,
.html-editor-area.form-control.is-valid,
.was-validated .html-editor-area.form-control:valid {
  background-position: top 17px right calc(0.375em + 0.1875rem);
}
>>> div.vue-lightbox-figure > div.swiper-container {
  background-color: transparent !important;
}
>>> .form-control.multifile-uploader,
>>> .form-control.multiselect {
  padding: 0;
  height: auto;
}
>>> .form-control.creditcard-area {
  height: auto;
}
>>> .multiselect--disabled .multiselect__tags {
  background-color: #e4e7ea;
}
>>> .multiselect--disabled {
  opacity: 0.9;
}
.input-control >>> .custom-checkbox {
  text-align: left;
}
>>> .is-invalid .multiselect.form-control {
  border: 1px solid #dc3545;
}
.vue-tel-input-area {
  padding-left: 0;
  padding-top: 2px;
  padding-bottom: 2px;
}
.input-control {
  min-height: 43px;
}

.video-area {
  display: inline-flex;
}
.video-area >>> input {
  width: auto;
}
.user-id-area {
  width: 100%;
}
>>> select.custom-select[disabled] {
  border-color: #e4e7ea !important;
}
.width-full {
  width: 100% !important;
  height: 53px;
}
.width-auto {
  width: auto !important;
}
.has-checkbox-label >>> label {
  font-size: 1.4rem;
}
.has-checkbox-label >>> .custom-control-label::before {
  height: 1.3rem;
  border-radius: 0.7rem;
  left: -2.25rem;
  width: 2rem;
}
.has-checkbox-label >>> .custom-control-label::after {
  width: calc(1.3rem - 4px);
  height: calc(1.3rem - 4px);
}
.force-flex {
  display: flex;
}
.force-flex input.form-control {
  width: 100px !important;
  border-top: 0.083333333333333rem solid #bebebe !important;
}
</style>
